import awsBidder from './awsBidder';
const BIDDER_NAME = 'a9';
const init = (config) => {
    if (!config.pubID) {
        return;
    }
    awsBidder();
    window.apstag.init({
        pubID: config.pubID,
        adServer: 'googletag',
    });
};
const fetchBids = (id, network, sizes, bidsBackHandler) => {
    const slot = {
        slotID: id,
        slotName: network,
        sizes,
    };
    window.apstag.fetchBids({ slots: [slot] }, () => {
        window.apstag.setDisplayBids();
        bidsBackHandler(BIDDER_NAME);
    });
};
export default {
    init,
    fetchBids,
};
//# sourceMappingURL=a9.js.map